export type AuthCaptchaAction = 'anonymous_signin' | 'password_signin' | 'password_reset' | 'signup_signin'
export type CaptchaTokenProvider = () => Promise<string | undefined>

export type AuthCaptchaFailure = 'failed' | 'expired' | 'timeout' | 'cancelled' | 'missing_site_key'

export class AuthCaptchaError extends Error {
  /**
   * @param code Turnstile's error code (or a local source label) when the widget
   *   reported one. Diagnostic only: it lives on the instance for Sentry and never
   *   goes into `message`.
   */
  constructor(
    readonly reason: AuthCaptchaFailure,
    readonly code?: string,
  ) {
    super('Auth CAPTCHA verification did not complete')
    this.name = 'AuthCaptchaError'
  }
}
